import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-physical-education',
  templateUrl: './physical-education.component.html',
  styleUrls: ['./physical-education.component.scss']
})
export class PhysicalEducationComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
